import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth, homeForRole } from "@/context/AuthContext";

// Layout route guard: renders the protected routes (Outlet) when signed in,
// otherwise bounces to /login and remembers where the user was headed.
//
// `allow` makes it ROLE-aware: pass the roles that may load this branch and
// anyone else is redirected to their own dashboard instead of rendering a shell
// they'll only get 403s inside. Omit it to allow any signed-in user.
//
// This guard deliberately knows nothing about two-factor authentication: 2FA is
// opt-in for every role, so no branch is ever withheld from an account that
// hasn't enrolled.
export default function RequireAuth({ allow }) {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // Fail CLOSED. `|| "tester"` used to mean a user with no role — or a role the
  // frontend doesn't know — was treated as a tester and handed the tester shell.
  const role = user?.role || null;
  if (!role) {
    return <Navigate to="/no-access" replace />;
  }
  if (allow && allow.length && !allow.includes(role)) {
    return <Navigate to={homeForRole(role)} replace />;
  }
  return <Outlet />;
}
